if (!customElements.get('smart-summary-scroll')) {
  customElements.define('smart-summary-scroll', class extends HTMLElement {
    connectedCallback() {
      this.setupScroll();
    }

    setupScroll() {
      const targetSelector = this.getAttribute('target-id');

      if (!targetSelector) {
        console.warn('smart-summary-scroll: target-id attribute is required');
        return;
      }

      this.style.cursor = 'pointer';
      this.style.userSelect = 'none';

      this.addEventListener('click', () => {
        this.scrollToTarget(targetSelector);
      });
    }

    scrollToTarget(targetSelector) {
      let selector = targetSelector.trim();

      // Auto-prefix with # if no selector prefix is provided
      if (!selector.match(/^[#\.\[]/)) {
        selector = '#' + selector;
      }

      const targetElement = document.querySelector(selector);

      if (!targetElement) {
        console.warn(`smart-summary-scroll: Target element with selector "${selector}" not found`);
        return;
      }

      // Adjust offset based on header height
      const header = document.querySelector('.header');
      const headerHeight = header ? header.offsetHeight : 0;
      const offset = headerHeight + 20; // 20px additional spacing

      const targetPosition = targetElement.offsetTop - offset;

      window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: 'smooth'
      });
    }
  });
}

// Modal Open/Close Handlers
document.addEventListener('click', function(e) {
  const target = e.target;
  const aiButton = target.closest('.smart-summary__ai-button, .js-modal-open-smart-summary-ai-popup');

  if (aiButton) {
    e.preventDefault();
    const modalId = aiButton.getAttribute('href');
    const modal = document.querySelector(modalId);

    if (modal && modal.tagName === 'MODAL-DIALOG') {
      modal.open(aiButton);
    }
  }
});
